import CustomList from '../Util/List/CustomList/CustomList';
import CustomListContainer from '../Util/List/CustomList/CustomListContainer';
import config from '../../../../config/config';
import React from 'react';
import { useSelector } from 'react-redux';
import { loadData } from '../Util/List/CustomList/loadData';

function List() {
  const sessionSelector = useSelector((state) => { return state.core.session });
  const friendly_url = sessionSelector.pdc_project_friendly_url;

  const type_view = sessionSelector.employee_payment_portal_view;

  const paths = {
    endpoint: config.endpoints.backend + 'portal/getindividualemployeepayments',
    endpointGetAllEmployees: config.endpoints.backend + 'portal/getallemployees',
    endpointGetAllDepartments: config.endpoints.backend + 'portal/getalldepartments'
  }

  const filters = {
    validateOnChange: true,
    showGoBackButton: false,
    showSubmitButton: false,
    handleSubmit: loadData,
    fields: [
      {
        name: 'pdc_filter_id',
        type: 'select',
        label: type_view == 'EMPLOYEE' ? 'Colaborador' : 'Departamento',
        options: [],
        optionsEndpoint: {
          endpoint: type_view == 'EMPLOYEE' ? paths.endpointGetAllEmployees : paths.endpointGetAllDepartments,
          label: type_view == 'EMPLOYEE' ? 'employee_name' : 'department_name',
          value: type_view == 'EMPLOYEE' ? 'id' : 'departmentid',
          params: {
            filter: {
              friendly_url
            }
          }
        },
        validations: {
          required: true
        },
        columnSize: 3
      },
      {
        name: 'filtro',
        type: 'submit',
        label: 'Pesquisar',
        columnSize: 1
      }
    ]
  }

  let list = {
    labelTitle: 'Ficha Salarial',
    icon: 'fa-receipt',
    filter: {
      friendly_url: friendly_url,
      type_view
    },
    formFilters: filters,
    columns: [
      {
        name: 'competency_date',
        label: 'Folha',
        width: '8%'
      },
      {
        name: type_view == 'EMPLOYEE' ? 'employee_name' : 'department_name',
        label: type_view == 'EMPLOYEE' ? 'Nome do Empregado' : 'Nome do Departamento',
        width: '20%'
      },
      {
        name: 'salary',
        label: 'Salário',
      },
      {
        name: 'fam_salary',
        label: 'Sal.Fam.',
      },
      {
        name: 'other_prov',
        label: 'Out.Prov.',
      },
      {
        name: 'inss',
        label: 'INSS',
      },
      {
        name: 'irrf',
        label: 'IRRF',
      },
      {
        name: 'other_desc',
        label: 'Out.Desc.',
      },
      {
        name: 'liquid_salary',
        label: 'Líquido',
      },
    ]
  };

  list = { ...list, ...paths };

  return (
    <div>
      <CustomListContainer
        canAdd={false}
        labelTitle={list.labelTitle}
        labelTitleButtonAdd={list.labelTitleButtonAdd}
        content={<CustomList list={{ ...list, ...paths }} />}
        icon={list.icon}
      />
    </div>
  );
}
export default List;
